export async function deleteData(url) {
    fetch(url, {
        method: 'DELETE',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' }
    })
    .catch(err => { console.error('Failed to delete data:', err); });
}

export async function getData(url) {
    try {
        console.log("Fetching:", url);

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const json = await response.json();
        
        // FIXED: Handle both {data: [...]} and raw array responses
        const result = json?.data !== undefined ? json.data : json;
        
        console.log("✅ getData returned:", result);
        return result;

    } catch (error) {
        console.error("❌ getData failed:", error);
        return [];   // Return empty array so the app doesn't crash
    }
}

export async function postData(url, data) {
    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    return response.json()
}

export async function updateData(url, data) {
    const response = await fetch(url, {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    return response.json()
}